import React from 'react'

import Horizontal from '../layouts/Horizontal.jsx'
import Card from '../components/Card.jsx'
import LoadingState from '../components/LoadingState.jsx'

import { getIncomeByAge } from '_services/insights-v2.js'
import useRequest from '../hooks/useRequest.js'

import BarStackedCartesianHOC from '../charts/BarStackedCartesianHOC.jsx'
import { AGES_MAP, formatIncomeBy, INCOMES_MAP } from '../../charts/helpers/formatters.js'

const COLORS = ['#060773', '#2B4C93', '#5399B7', '#5CD6CB', '#52BB8E', '#2C9344', '#0A7104']

const IncomeByAge = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1 } = props.data

  const { data, loading } = useRequest(getIncomeByAge, { audienceId, timeRange: null }, true)

  const formatted = formatIncomeBy(data, AGES_MAP, INCOMES_MAP)

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <Choose>
            <When condition={loading}>
              <LoadingState />
            </When>
            <Otherwise>
              <BarStackedCartesianHOC
                data={formatted}
                colors={COLORS}
                mode="stacked"
                labels={{ y: 'Users %', x: 'Age' }}
              />
            </Otherwise>
          </Choose>
        </Card>
      )}
    />
  )
}

export default IncomeByAge
